export default {
  custom_additive: {
    placeholder: 'Benutzerdefinierte Option hinzufügen',
  },
  buttons: {
    add: 'Hinzufügen',
  },
};
